<template>
  <MainLayout>
    <div class="text-center mt-4" v-if="loader">
      <Loader
        :size="'big'"
      />
    </div>
    <div class="mt-4" v-else>
      <div class="pdf-wrapper col-md-8 mx-auto">
        <template v-if="src">
          <div class="mb-3 text-center">
            <Button
              class="btn-color9"
              @click.prevent="printPdf"
            >
              {{ $t('download') }}
            </Button>
          </div>
          <pdf ref="pdfComponent" :src="src"></pdf>
        </template>
      </div>
    </div>
  </MainLayout>
</template>

<script>

import OrdersService from '@/modules/orders/services/orders-service'

import Button from '@/components/common/Button/Button'
import Loader from '@/components/common/Loader/Loader'
import MainLayout from '@/components/layouts/MainLayout'
import pdf from 'vue-pdf'

export default {
  components: {
    Button,
    pdf,
    Loader,
    MainLayout
  },
  data () {
    return {
      loader: false,
      src: ''
    }
  },
  created () {
    this.getPDF()
  },
  methods: {
    /**
     * Get PDF from API
     */
    async getPDF () {
      this.loader = true
      try {
        const data = await OrdersService.downloadNFSe(this.$route.params.id)
        var raw = window.atob(data)
        var rawLength = raw.length
        var array = new Uint8Array(new ArrayBuffer(rawLength))

        for (var i = 0; i < rawLength; i++) {
          array[i] = raw.charCodeAt(i)
        }
        this.src = array
        // this.src = JSON.parse(data)
      } catch (error) {
        console.log(error)
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    },
    /**
     * print PDF
     */
    printPdf () {
      const blob = new Blob([this.src], { type: 'application/pdf' })
      const iframe = document.createElement('iframe')

      iframe.style.display = 'none'
      iframe.src = URL.createObjectURL(blob)

      document.body.appendChild(iframe)

      iframe.onload = () => {
        iframe.contentWindow.focus()
        iframe.contentWindow.print()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
